import type {
  Project,
  GameDocument,
  Entity,
  Board,
  Asset,
  Category,
} from "./types";
import type { Scene } from "./game/types";
export type Snapshot = {
  project: Project;
  documents: GameDocument[];
  entities: Entity[];
  boards: Board[];
  scenes: Scene[];
  assets: Asset[];
  categories: Category[];
};
export type Checkpoint = {
  id: string;
  title: string;
  description: string;
  createdAt: string;
  counts: Record<
    "documents" | "boards" | "entities" | "scenes" | "assets",
    number
  >;
};
export type CheckpointDetail = Checkpoint & { snapshot: Snapshot };
export type Playtest = {
  id: string;
  projectId: string;
  checkpointId: string;
  sceneId: string;
  title: string;
  hypothesis: string;
  observations: string;
  decision: string;
  status: "untested" | "confirmed" | "changes";
  version: number;
  createdAt: string;
  updatedAt: string;
};
export const testStatuses = {
  untested: "Не проверено",
  confirmed: "Подтверждено",
  changes: "Требует изменений",
};
